function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PieChart from '../components/PieChart';
import DashCard from '../components/DashCard';
const ClaimStatePieChart = _ref => {
  let {
    dashboardData,
    ...props
  } = _ref;
  const labels = ['Total Projects', 'R&D Projects'];
  const seriesvisitors = [dashboardData.total_project_count || 0, dashboardData.system_project_count];
  return /*#__PURE__*/React.createElement(DashCard, _extends({}, props, {
    title: "R&D Projects v Total Projects",
    className: "h-100"
  }), /*#__PURE__*/React.createElement(PieChart, {
    className: "pos-rel-top-10",
    labels: labels,
    series: seriesvisitors,
    label: 'Total Projects'
  }));
};
export default ClaimStatePieChart;